import MapElement from './MapElement';
import FeatureDrawer from '../helpers/FeatureDrawer';
import VectorLayer from 'ol/layer/Vector';
import Point from 'ol/geom/Point';

import * as olExtent from 'ol/extent';
import 'ol/ol.css';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import LineString from 'ol/geom/LineString';

import LayerGroup from 'ol/layer/Group';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import WebGLVectorLayerRenderer from 'ol/renderer/webgl/VectorLayer';

import Layer from 'ol/layer/Layer';

import MotionplanColors from '../helpers/MotionplanColors';

import { Stroke, Circle, Fill, Style } from 'ol/style.js';
import { MultiPoint } from "ol/geom";

class WebGLLayer extends Layer {
    constructor(options) {
        super(options);
        this.style = options.style;
    }

    createRenderer() {
        return new WebGLVectorLayerRenderer(this, {
            className: this.getClassName(),
            style: this.style,
        });
    }
}

export default class MapWebGLMotionplanCollection extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent)
        this.parentId = parent.id;
        this.selectedMotionplan = null;

        // this.motionplans = [];

        this.pointSource = null;
        this.lineSource = null;

        this.pointLayer = null;
        this.lineLayer = null;

        this.selectSource = null;
        this.selectLayer = null;

        this.connectedSource = null;
        this.connectedLayer = null;

        this.isSelected = false; // fix

        this.pointStyle;
        this.lineStyle;
    }

    // START MOTIONPLANCOLLECTIONINTERFACE

    addMotionplan(motionplan, projection, visible = true, existing = true) {
        if (!this.layer) { this.drawLayer() }
        if (this.projection != projection) { this.projection = projection } // eventually if differing projections maybe usefull?

        const childSettings = {
            clickmethod: this.mapElementSettings.clickmethod,
            interactable: true,
            group: true,
            defaultOn: visible,
            editButton: existing // if its a non existing mp (not saved yet) dont add editbutton
            // actions: this.mapElementSettings.actions // maybe use actions checkbox in layerlist to delete motionplans??
        }

        const mp = new MotionplanElement(this.mapModel, motionplan.id, childSettings, this)
        mp.drawLayer(motionplan, projection);
        this.mapElements.push(mp);

        // this.drawLayers()
    }

    findMotionplanElement(id) {
        return this.mapElements.find(mapElement => mapElement.id == id)
    }

    drawLayer() {
        if (!this.layer) {
            console.log("SET LAYERS")

            this.layer = new LayerGroup({
                parentId: this.id,
                layers: [],
                zIndex: 0
            });

            this.setStyle()

            this.lineSource = new VectorSource()
            this.lineLayer = new WebGLLayer({
                parentId: this.id,
                source: this.lineSource,
                style: this.lineStyle,
                zIndex: 1
            });
            this.layer.getLayers().push(this.lineLayer);

            this.pointSource = new VectorSource();
            this.pointLayer = new WebGLPointsLayer({
                parentId:  this.id,
                source: this.pointSource,
                style: this.pointStyle,
                zIndex: 2
            });
            this.layer.getLayers().push(this.pointLayer);

            var c;
            if (this.mapModel.dark) {
                c = "rgba(0,0,0,0.1)"
            } else {
                c = "rgba(255,255,255,0.1)"
            }

            const globalMpStyle = (ft, res, dark) => {
                const styles = [new Style({
                    stroke: new Stroke({
                        width: 0.1,
                        color: c
                    })
                })]
                const geometry = ft.getGeometry();
                const coords = geometry.getCoordinates();

                const firstPoint = coords[0]
                const lastPoint = coords[coords.length - 1]

                return [
                     ...styles,
                    new Style({
                        geometry: new MultiPoint([firstPoint]),
                        image: new Circle({
                            fill: new Fill({
                                color: "#4caf50" // "#00008c"
                            }),
                            radius: 8,
                        }),
                    }), new Style({
                        geometry: new MultiPoint([lastPoint]),
                        image: new Circle({
                            fill: new Fill({
                                color: "#4caf50" // "#00008c"
                            }),
                            radius: 8,
                        }),
                    })]
            }


            this.selectSource = new VectorSource()
            this.selectLayer = new VectorLayer({
                parentId: this.id,
                source: this.selectSource,
                zIndex: 0,
                style: globalMpStyle
            })



            this.layer.getLayers().push(this.selectLayer);

            const connectedStyle = (feature) => {
                const geomType = feature.getGeometry().getType();
                if (geomType === 'LineString') {
                    const styles = [new Style({
                        stroke: new Stroke({
                            color: '#808080',  // Gray color for the line
                            width: 1           // Width of the line
                        })
                    })];
                    const coordinates = feature.getGeometry().getCoordinates();

                    if (coordinates.length > 0) {
                        // Start point
                        styles.push(new Style({
                            geometry: new Point(coordinates[0]),
                            image: new Circle({
                                fill: new Fill({
                                    color: '#ff0000'  // Red color for the endpoint
                                }),
                                radius: 5,           // Size of the endpoint dot
                                stroke: new Stroke({
                                    color: '#ff0000', // Red border for the endpoint dot
                                    width: 2
                                })
                            })
                        }));

                        // End point
                        styles.push(new Style({
                            geometry: new Point(coordinates[coordinates.length - 1]),
                            image: new Circle({
                                fill: new Fill({
                                    color: '#ff0000'  // Red color for the endpoint
                                }),
                                radius: 4,           // Size of the endpoint dot
                                stroke: new Stroke({
                                    color: '#ff0000', // Red border for the endpoint dot
                                    width: 2
                                })
                            })
                        }));
                    }

                    return styles;
                } else if (geomType === 'Point') {
                    return new Style({
                        image: new Circle({
                            fill: new Fill({
                                color: '#ff0000'  // Red color for the point
                            }),
                            radius: 4,           // Size of the point dot
                            stroke: new Stroke({
                                color: '#ff0000', // Red border for the point dot
                                width: 2
                            })
                        })
                    });
                }

                return null;
            };

            this.connectedSource = new VectorSource()
            this.connectedLayer = new VectorLayer({
                parentId: this.id,
                source: this.connectedSource,
                zIndex: 15,
                style: connectedStyle
            })
            this.layer.getLayers().push(this.connectedLayer);

            this.parent.layer.getLayers().push(this.layer);

            if (!this.mapElementSettings.defaultOn) {
                this.hide();
            }
        }
    }

    hideAllOthers(id) {
        // console.log("TODO IMPLEMENT hideAllOthers");
        if (this.mapElements.length > 0) {
            this.mapElements.forEach(mapElement => {
                if (mapElement.id != id) mapElement.hide();
            });
        }
    }

    selectMotionplan(id) {
        
        this.mapElements.forEach(mapElement => {
            if (mapElement.id == id) {
                mapElement.selectMotionplan();
                this.selectedMotionplan = id;
            }
        });
    }

    clear() {
        this.unselectAll();
        this.clearSources();
        this.layer = null
        this.mapElements.length = 0;
    }

    getVisibleMotionplans() {
        const col = []
        this.mapElements.forEach(mapElement => {
            if (mapElement.visible) {
                col.push(mapElement.id)
            }
        })
        return col;
    }

    unselectAll() {
        super.unselectAll();
        this.mapElements.forEach(mapElement => {
            mapElement.deselectMotionplan()
        });
        this.selectedMotionplan = null;
    }

    // END MOTIONPLANCOLLECTIONINTERFACE

    getExtent() {
        if (this.layer) return this.layer.getLayers().getArray()[0].getSource().getExtent();
        return null;
    }

    clearSources() {
        this.lineSource?.clear();
        this.pointSource?.clear();
        this.selectSource?.clear();
        this.connectedSource?.clear();
    }

    setStyle() {
        this.lineStyle = [
            {
                variables: {
                    dark: Number(this.mapModel.dark) // dark should be cast to int because styles are weird
                },
                "stroke-width":
                    [
                        "case",
                        ["==", ["get", "selected"], 1],
                        ["match",
                            ["get", "lineType"],                   // Feature parameter for color
                            "spray", 4,
                            "drive", 3,
                            3],
                        0
                    ],
                "stroke-color": "#FFFFFF", // motionplancolor selected background
                'stroke-miter-limit': 10,
                'stroke-line-cap': "butt",
                'stroke-line-join': "miter"
            },
            {
                variables: {
                    dark: Number(this.mapModel.dark) // dark should be cast to int because styles are weird
                },
                "stroke-width": ["match",
                    ["get", "lineType"],                   // Feature parameter for color
                    "spray", 2,
                    "drive", 1,
                    2],
                "stroke-color": [
                    "case",
                    ["==", ["get", "selected"], 1],
                    ["case",
                        ["==", ["var", "dark"], 1],
                        ["match",
                            ["get", "lineType"],                   // Feature parameter for color
                            "spray", MotionplanColors.line.spray.selected.dark,
                            "drive", MotionplanColors.line.drive.selected.dark,
                            "#FFFFFF"], // When dark and selected
                        ["match",
                            ["get", "lineType"],                   // Feature parameter for color
                            "spray", MotionplanColors.line.spray.selected.default,
                            "drive", MotionplanColors.line.drive.selected.default,
                            "#000000"] // When selected but not dark
                    ],
                    [
                        "case",
                        ["==", ["var", "dark"], 1],
                        ["match",
                            ["get", "lineType"],                   // Feature parameter for color
                            "spray", MotionplanColors.line.spray.dark,
                            "drive", MotionplanColors.line.drive.dark,
                            "#FFFFFF"], // When dark but not selected
                        ["match",
                            ["get", "lineType"],                   // Feature parameter for color
                            "spray", MotionplanColors.line.spray.default,
                            "drive", MotionplanColors.line.drive.default,
                            "#000000"] // When not selected and not dark
                    ]
                ],
                'z-index': [
                    'case',
                    ['==', ['get', 'selected'], 1],
                    10,   // draw selected features on top
                    0
                ],
                'stroke-miter-limit': 10,
                'stroke-line-cap': "butt",
                'stroke-line-join': "miter"
            }
        ]

        this.pointStyle = {
            variables: {
                dark: Number(this.mapModel.dark),
            },
            "z-index": [
                "case",
                ["==", ["get", "selected"], 1],
                10,
                0
            ],
            "circle-opacity": 1,
            "circle-radius": [
                "match",
                ["get", "pointType"],                   // Feature parameter for color
                "spray", 4,
                "drill", 4,
                "drive", 2,
                "stop", 4,
                4                           // Default color
            ], //["get", "radius"],
            "circle-stroke-color":
                [
                    "case",
                    ["==", ["get", "selected"], 1],
                    ["case",
                        ["==", ["var", "dark"], 1],
                        [
                            "match",
                            ["get", "pointType"],                   // Feature parameter for color
                            "spray", MotionplanColors.point.spray.selected.stroke.dark,
                            "drill", MotionplanColors.point.drill.selected.stroke.dark,
                            "drive", MotionplanColors.point.drive.selected.stroke.dark,
                            "stop", MotionplanColors.point.stop.selected.stroke.dark,
                            "#000000"                           // Default color
                        ],
                        [
                            "match",
                            ["get", "pointType"],                   // Feature parameter for color
                            "spray", MotionplanColors.point.spray.selected.stroke.default,
                            "drill", MotionplanColors.point.drill.selected.stroke.default,
                            "drive", MotionplanColors.point.drive.selected.stroke.default,
                            "stop", MotionplanColors.point.stop.selected.stroke.default,
                            "#000000"                           // Default color
                        ],
                    ],
                    [
                        "case",
                        ["==", ["var", "dark"], 1],
                        [
                            "match",
                            ["get", "pointType"],                   // Feature parameter for color
                            "spray", MotionplanColors.point.spray.stroke.dark,
                            "drill", MotionplanColors.point.drill.stroke.dark,
                            "drive", MotionplanColors.point.drive.stroke.dark,
                            "stop", MotionplanColors.point.stop.stroke.dark,
                            "#000000"                           // Default color
                        ],
                        [
                            "match",
                            ["get", "pointType"],                   // Feature parameter for color
                            "spray", MotionplanColors.point.spray.stroke.default,
                            "drill", MotionplanColors.point.drill.stroke.default,
                            "drive", MotionplanColors.point.drive.stroke.default,
                            "stop", MotionplanColors.point.stop.stroke.default,
                            "#000000"                           // Default color
                        ],
                    ]
                ],
            "circle-fill-color":
                [
                    "case",
                    ["==", ["get", "selected"], 1],
                    ["case",
                        ["==", ["var", "dark"], 1],
                        [
                            "match",
                            ["get", "pointType"],                   // Feature parameter for color
                            "spray", MotionplanColors.point.spray.selected.fill.dark,
                            "drill", MotionplanColors.point.drill.selected.fill.dark,
                            "drive", MotionplanColors.point.drive.selected.fill.dark,
                            "stop", MotionplanColors.point.stop.selected.fill.dark,
                            "#000000"                           // Default color
                        ],
                        [
                            "match",
                            ["get", "pointType"],                   // Feature parameter for color
                            "spray", MotionplanColors.point.spray.selected.fill.default,
                            "drill", MotionplanColors.point.drill.selected.fill.default,
                            "drive", MotionplanColors.point.drive.selected.fill.default,
                            "stop", MotionplanColors.point.stop.selected.fill.default,
                            "#000000"                           // Default color
                        ],
                    ],
                    [
                        "case",
                        ["==", ["var", "dark"], 1],
                        [
                            "match",
                            ["get", "pointType"],                   // Feature parameter for color
                            "spray", MotionplanColors.point.spray.fill.dark,
                            "drill", MotionplanColors.point.drill.fill.dark,
                            "drive", MotionplanColors.point.drive.fill.dark,
                            "stop", MotionplanColors.point.stop.fill.dark,
                            "#000000"                           // Default color
                        ],
                        [
                            "match",
                            ["get", "pointType"],                   // Feature parameter for color
                            "spray", MotionplanColors.point.spray.fill.default,
                            "drill", MotionplanColors.point.drill.fill.default,
                            "drive", MotionplanColors.point.drive.fill.default,
                            "stop", MotionplanColors.point.stop.fill.default,
                            "#000000"                           // Default color
                        ],
                    ]
                ],
            "circle-stroke-width": 1,
        }
    }

    deselectMotionplan() {

        console.error("IMPLEMENT DESELECT ON COLLECTION (DONT USE THIS ONE)")
    }

    combineFeatures() {
        this.mapElements.forEach((mapElement) => {
            mapElement.combineFeatures();
        })
    }
}

class MotionplanElement { // ARE THERE MORE MAP ELEMENT FUNCTIONS MISSING?
    constructor(map, id, mapElementSettings, parent) {
        this.mapModel = map
        this.id = id
        this.mapElementSettings = mapElementSettings
        this.parent = parent

        this.noKey = true;

        this.isSelected = false;

        this.motionplan = null;
        this.projection = null;

        this.sources = [];
        this.visible = true;
        this.drawn = false;
        this.connected = false;
    }

    drawLayer(motionplan, projection) {
        this.motionplan = motionplan;
        this.projection = projection;
        this.layer = {
            parentId: this.parent.id,
            get(arg) {
                return this[arg]
            }
        }
        this.setSources()

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        } else {
            this.show()
        }
    }

    draw() {
        console.error("IMPLEMENT draw (not needed?)")
    }

    setSources() {
        var featureDrawer = new FeatureDrawer(this.projection, this.mapModel.projection);

        const mpLineSource = [];
        const mpPointSource = [];
        const mpSelectSource = [];
        const mpConnectedSource = [];

        const sources = { 
            mpLineSource: mpLineSource, 
            mpPointSource: mpPointSource, 
            mpSelectSource: mpSelectSource,
            mpConnectedSource: mpConnectedSource,
        }

        this.sources = sources

        const selectLinePoints = [];

        let lastSegment;
        this.motionplan.data.forEach((segment, index) => {
            let feature = null;

            if (lastSegment) {
                if (segment.CentreX != 0 && segment.CentreY != 0) {
                    var curvature = segment.Curvature
                    const clockwise = curvature < 0;
                    var center = { x: segment.CentreX, y: segment.CentreY };
                    var startPoint = { x: lastSegment.X, y: lastSegment.Y };
                    var arc;
                    var startAngle = segment.SegmStartAngle;
                    var endAngle = segment.SegmEndAngle;
                    var r = Math.sqrt(Math.pow(center.x - startPoint.x, 2) + Math.pow(center.y - startPoint.y, 2));

                    var points = [];

                    if (clockwise) {
                        let difference = startAngle - endAngle;
                        if (difference < 0) {
                            difference += 2 * Math.PI;
                        }

                        let rotatedAngle, x, y;
                        endAngle = endAngle + (0.5 * Math.PI);

                        for (let i = 0; i < (difference * (180 / Math.PI)); ++i) {
                            rotatedAngle = endAngle + (i * (Math.PI / 180));
                            x = center.x + (r * Math.cos(rotatedAngle));
                            y = center.y + (r * Math.sin(rotatedAngle));
                            let vertex = { x: x, y: y }
                            if (this.projection != null) {
                                vertex = featureDrawer.transformCoordinates(vertex);
                            }
                            points.push([vertex.x, vertex.y]);
                        }
                        rotatedAngle = startAngle + (0.5 * Math.PI);
                        x = center.x + (r * Math.cos(rotatedAngle));
                        y = center.y + (r * Math.sin(rotatedAngle));
                        let vertex = { x: x, y: y }
                        if (this.projection != null) {
                            vertex = featureDrawer.transformCoordinates(vertex);
                        }
                        points.push([vertex.x, vertex.y]);

                        selectLinePoints.push(...[...points].reverse())
                    } else {
                        let difference = endAngle - startAngle;
                        if (difference < 0) {
                            difference += 2 * Math.PI;
                        }
                        let rotatedAngle, x, y;
                        startAngle = startAngle - (0.5 * Math.PI);
                        for (let i = 0; i < (difference * (180 / Math.PI)); ++i) {
                            rotatedAngle = startAngle + (i * (Math.PI / 180));
                            x = center.x + (r * Math.cos(rotatedAngle));
                            y = center.y + (r * Math.sin(rotatedAngle));
                            let vertex = { x: x, y: y }
                            if (this.projection != null) {
                                vertex = featureDrawer.transformCoordinates(vertex);
                            }
                            points.push([vertex.x, vertex.y]);
                        }
                        rotatedAngle = endAngle - (0.5 * Math.PI);
                        x = center.x + (r * Math.cos(rotatedAngle));
                        y = center.y + (r * Math.sin(rotatedAngle));
                        let vertex = { x: x, y: y }
                        if (this.projection != null) {
                            vertex = featureDrawer.transformCoordinates(vertex);
                        }
                        points.push([vertex.x, vertex.y]);

                        selectLinePoints.push(...points)
                    }

                    arc = new LineString(points);
                    feature = new Feature(arc);
                } else {
                    let vertex = { x: segment.X, y: segment.Y }
                    if (this.projection != null) {
                        vertex = featureDrawer.transformCoordinates(vertex);
                    }
                    selectLinePoints.push([vertex.x, vertex.y])

                    feature = featureDrawer.drawFeature(
                        {
                            type: "LINE",
                            start: { x: lastSegment.X, y: lastSegment.Y },
                            end: { x: segment.X, y: segment.Y }
                        }
                    );
                }
                feature.set("arguments", segment.functionArray);
                feature.set("motionplanSegmentIndex", index);
                feature.set("motionplanElementId", this.id);
                this.setFeatureValues(feature, false)

                mpLineSource.push(feature);
            } else {
                let vertex = { x: segment.X, y: segment.Y }
                if (this.projection != null) {
                    vertex = featureDrawer.transformCoordinates(vertex);
                }
                selectLinePoints.push([vertex.x, vertex.y])
            }

            const featurePoint = featureDrawer.drawFeature({ type: "POINT", x: segment.X, y: segment.Y })
            featurePoint.set("arguments", segment.functionArray);
            featurePoint.set("motionplanSegmentIndex", index);
            featurePoint.set("motionplanElementId", this.id);

            this.setFeatureValues(featurePoint, false)

            mpPointSource.push(featurePoint);

            lastSegment = segment;
        });

        if (selectLinePoints.length > 1) {
            const combinedLineString = new LineString(selectLinePoints)
            const combinedFeature = new Feature(combinedLineString);
            combinedFeature.set("motionplan",  this.motionplan);
            mpConnectedSource.push(combinedFeature);
        } else {
            const point = new Point(selectLinePoints[0])
            const combinedFeature = new Feature(point);
            combinedFeature.set("motionplan",  this.motionplan);
            mpConnectedSource.push(combinedFeature);
        }
        const line = new LineString(selectLinePoints);
        const selectLine = new Feature(line);
        selectLine.set("motionplanElementId", this.id);
        mpSelectSource.push(selectLine);
    }

    checkForMotionplanFunctionAndOrArgument(ft, id, arg = null) {
        if (arg !== null) {
            return ft.get("arguments").some(s => {
                return (s.IdentifierFunction == id && s.Arguments[0] == arg)
            })
        } else {
            return ft.get("arguments").some(s => {
                return (s.IdentifierFunction == id)
            })
        }
    }

    setFeatureValues(ft, selected) {
        if (selected) {
            ft.set("selected", 1)
        } else {
            ft.set("selected", 0)
        }

        if (ft.getGeometry().getType() == "Point") {
            if (this.checkForMotionplanFunctionAndOrArgument(ft, 1)) {
                ft.set("pointType", "spray")
            } else if (this.checkForMotionplanFunctionAndOrArgument(ft, 2)) {
                ft.set("pointType", "drill")
            } else if (this.checkForMotionplanFunctionAndOrArgument(ft, 3)) {
                ft.set("pointType", "stop")
            } else {
                ft.set("pointType", "drive")
            }
        } else { // lines
            if (this.checkForMotionplanFunctionAndOrArgument(ft, 51, 1)) {
                ft.set("lineType", "spray")
            } else if (this.checkForMotionplanFunctionAndOrArgument(ft, 51, 0)) {
                ft.set("lineType", "drive")
            }
        }
    }

    getExtent() {
        this.parent.getExtent()
        console.error("IMPLEMENT getExtent for individual mp")
    }

    getFeatureFromPoint(coordinates) {
        console.log(this)

        // this.sources.mpPointSource this.sources.mpLineSource

        // const pointFeatures = this.pointSource.getFeatures()
        // const lineFeatures = this.lineSource.getFeatures()

        var closestFeature;
        var closestDistance = Infinity;

        // put pointFeatures first, this way if a point is closest the point gets selected first. i think this is better.
        const features = [...this.sources.mpPointSource, ...this.sources.mpLineSource]

        features.forEach(feature => {
            const closestPoint = feature.getGeometry().getClosestPoint(coordinates)

            // Calculate Euclidean distance using Pythagorean theorem
            const dx = closestPoint[0] - coordinates[0];
            const dy = closestPoint[1] - coordinates[1];
            const distance = Math.sqrt(dx * dx + dy * dy); // Pythagorean distance

            // Check if this distance is smaller than the current minimum distance
            if (distance < closestDistance) {
                closestDistance = distance;
                closestFeature = feature; // Update the closest feature
            }
        })

        return closestFeature
    }

    // setStyle() {
    //     console.error("IMPLEMENT setStyle")
    // }

    deselectMotionplan() {
        this.isSelected = false;

        const featureArray = [...this.sources.mpLineSource, ...this.sources.mpPointSource]

        if (this.parent.selectInteraction) {
            this.parent.selectInteraction.getFeatures().clear();
        }

        featureArray.forEach(ft => {
            this.setFeatureValues(ft, false)
        })
    }

    selectMotionplan() {
        // if (!this.isSelected) {
            // this.layer.setZIndex(10);
            // this.lineLayer.setZIndex(11);
            // this.pointLayer.setZIndex(13);
            this.isSelected = true;
            const selectedFeatures = []


            selectedFeatures.push(...this.sources.mpLineSource, ...this.sources.mpPointSource)

            // check if this still works when implementing multiple mps on tmi
            if (this.parent.selectInteraction) {
                this.parent.selectInteraction.getFeatures().clear();
            }


            selectedFeatures.forEach(ft => {
                this.setFeatureValues(ft, true)
                if ( this.parent.selectInteraction) {
                     this.parent.selectInteraction.getFeatures().push(ft);
                }
            })

            if (this.connected && this.parent.selectInteraction && this.sources.mpConnectedSource.length > 0) {
                this.parent.selectInteraction.getFeatures().push(...this.sources.mpConnectedSource);
            }
        // }
    }

    selectSegment(segmentIndex) {
        // console.error("selectSegment FROM CHILD")
        // console.error("IMPLEMENT selectSegment TEST")

        this.parent.unselectAll()

        var selectedFeatures = [...this.sources.mpLineSource, ...this.sources.mpPointSource].filter(feature => {
            return feature.get("motionplanSegmentIndex") == segmentIndex
        });

        this.parent.selectInteraction.getFeatures().clear();
        if (selectedFeatures) {
            selectedFeatures.forEach(feature => {
                this.setFeatureValues(feature, true)
                this.parent.selectInteraction.getFeatures().push(feature);
            })

            const totalExtend = selectedFeatures.reduce((te, feature) => {
                if (te) {
                    return olExtent.extend(te, feature.getGeometry().getExtent())
                } else {
                    return feature.getGeometry().getExtent()
                }
            }, null)

            var center = olExtent.getCenter(totalExtend);

            var size = this.mapModel.map.getSize();

            var mostLeftCoords = this.mapModel.map.getCoordinateFromPixel([0, 0]);
            var mostRightCoords = this.mapModel.map.getCoordinateFromPixel([size[0], 0]);

            var offset = (mostRightCoords[0] - mostLeftCoords[0]) / 6

            var view = this.mapModel.map.getView();

            view.animate({
                center: [center[0] - offset, center[1]],
                duration: 100 // duration in milliseconds
            });
        }
    }

    combineFeatures() {
        this.hide();
        this.connected = true;
        this.show();
    }

    // MAPELEMENT FUNCTION
    hide() {
        this.visible = false;

        if (this.drawn) {
            if (this.connected) {
                console.log("test")
                this.parent.connectedSource.removeFeatures(this.sources.mpConnectedSource)

            } else {
                this.parent.lineSource.removeFeatures(this.sources.mpLineSource)
                this.parent.pointSource.removeFeatures(this.sources.mpPointSource)
                this.parent.selectSource.removeFeatures(this.sources.mpSelectSource)
            }
            this.drawn = false
        }
    }

    show() {
        this.visible = true;
        if (!this.drawn) {
            if (this.connected) {
                this.parent.connectedSource.addFeatures(this.sources.mpConnectedSource)
            } else {
                this.parent.lineSource.addFeatures(this.sources.mpLineSource)
                this.parent.pointSource.addFeatures(this.sources.mpPointSource)
                this.parent.selectSource.addFeatures(this.sources.mpSelectSource)
            }

            this.drawn = true
        }
        // Reveal the non-grouped collection without changing sibling visibility.
        if (!this.parent.visible) this.parent.show()
    }
        
    showChildren() {
        // no need to check if visible, it will do it on its own if this layer is not visible by showing from the child element. 
        // exmpl: MOTIONPLANCOLLECTION.visible: false
        this.show()
    }

    getLayers() {
        const layerObject = { id: this.parent.id + "-" + this.id, name: this.motionplan.name, editButton: this.mapElementSettings.editButton, actions: this.mapElementSettings.actions, checkBoxValue: false, visible: this.visible, disabled: this.disabled, show: this.show.bind(this), hide: this.hide.bind(this), children: [] };
        if (!this.noKey) layerObject.key = this.id;
        return layerObject
    }
}